export default function Business() {
  return (
    <div>
      <script
        async
        type="text/javascript"
        src="https://cdns.gigya.com/JS/gigya.js?apiKey=3_GE23JX1gIDl0aJB2e9TaRhVZyxcaF8xLpfvRTj1HxjC6Gs_KSNZOOAbSCwueaCpd&lang=en-gb"
      />
      <script async type="text/javascript" src="//cdn.gigya-ext.com/gy.js" />
      <div className="gy-ui-screen-set" data-screen-set="ULVR_prefCentre_v1" />
    </div>
  );
}
